import React from 'react';
import { useLocation } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import Navbar from './components/layout/Navbar';

function App() {
  const location = useLocation();
  const isPublicPortal = ['/', '/scan', '/scratch', '/reward'].includes(location.pathname);
  const isAdminPath = location.pathname.startsWith('/admin') || location.pathname.startsWith('/super-admin');

  return (
    <div className="min-h-screen bg-[#fdfdfd] selection:bg-[#d4af37]/30">
      {!isAdminPath && !isPublicPortal && <Navbar />}
      <main>
        <AppRoutes />
      </main>
    </div>
  );
}


export default App;

